import { PreviewPrescription } from '../../../components'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import RaytebModal from './RaytebModal'
import { useState, useEffect } from 'react'
const PreviewPrescriptionModal = ({
  prescription,
  isOpen,
  hideModal,
}: {
  prescription: PrescriptionViewModel
  isOpen: boolean
  hideModal: () => void
}) => {
  return (
    <RaytebModal
      isOpen={isOpen}
      hideModal={() => hideModal()}
      className={'w-full h-full'}
      title='پیش نمایش نسخه ارجاع شده'
    >
      <PreviewPrescription {...prescription} />
    </RaytebModal>
  )
}

export default PreviewPrescriptionModal
